import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context('.', false, /totem-[\w-]+\.vue$/)

export default (Vue) => requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const cleared = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
    const componentName = upperFirst(camelCase(cleared))
    Vue.component(componentName, componentConfig.default || componentConfig)
})
